// 九畴云市 · 产品架构数据

export const jiuchouPosition = {
  eyebrow: '核心战略项目',
  title: '九畴云市',
  subtitle: '乡村数字经济操作系统',
  desc: '以 TOMA 智能体为智能入口，以数字货架为商业载体，以 ePin 为数据底座，以数字消费为应用场景，以智能清分和产业协同形成可复制的县域数字商业基础设施。',
};

// 一条主线
export const mainLine = [
  { zh: '人', en: 'People' },
  { zh: '货', en: 'Goods' },
  { zh: '店', en: 'Store' },
  { zh: '场', en: 'Scene' },
  { zh: '交易', en: 'Trade' },
  { zh: '履约', en: 'Fulfill' },
  { zh: '数据', en: 'Data' },
  { zh: 'AI', en: 'AI' },
  { zh: '清分', en: 'Settle' },
  { zh: '产业价值', en: 'Value' },
  { zh: '再增长', en: 'Growth' },
];

// 五大数字基础设施
export const fiveInfra = [
  {
    no: '01',
    name: 'TOMA 智能体',
    tag: 'AI 入口',
    icon: 'ri-robot-2-line',
    roles: ['智能问答', '商品推荐', '场景服务', '消费辅助', '经营辅助', 'AI 运营'],
    desc: '与 414 号文「智能体」方向高度对应的核心能力，规划 TOMA 公共服务智能体与 ROT 便捷化智能服务工具。',
  },
  {
    no: '02',
    name: '数字货架',
    tag: '商业入口',
    icon: 'ri-store-2-line',
    roles: ['数字资产', '商品展示', '交易入口', '数据回流'],
    desc: '数字资产 → 商品展示 → 交易入口 → 数据回流，把分散商品组织成可运营的数字货架。',
  },
  {
    no: '03',
    name: 'ePin',
    tag: '商品数字身份',
    icon: 'ri-qr-code-line',
    roles: ['一物一码', '产品身份', '品质信息', '生产信息', '溯源信息', '数字货架绑定'],
    desc: 'ePin 产品包涵盖产品上链、品质认证、数字身份、数字货架，为每件商品赋予可信身份。',
  },
  {
    no: '04',
    name: '数字消费',
    tag: '消费权益引擎',
    icon: 'ri-red-packet-line',
    roles: ['消费权益', '红包', '券', '核销', '消费场景', '数据回流'],
    desc: '把政策型数字消费工具转化为真实消费场景。',
  },
  {
    no: '05',
    name: '智能清分',
    tag: '价值分配引擎',
    icon: 'ri-flow-chart',
    roles: ['订单', '贡献', '规则', '计算', '清分', '对账', '数据沉淀'],
    desc: '「七方共利清分系统」已列入九畴云市核心产品组合。',
  },
];

// 用户与角色层
export const userRoles = [
  { icon: 'ri-shopping-bag-3-line', name: '消费者', desc: '买商品、买服务、消费、评价、分享。' },
  { icon: 'ri-user-search-line', name: '云社员', desc: '寻货、卖货、服务、分享、贡献。' },
  { icon: 'ri-store-2-line', name: '云店长', desc: '经营数字店铺、管理商品、订单、客户。' },
  { icon: 'ri-lightbulb-flash-line', name: '云创客', desc: '建设和运营县域数字商业网络。' },
  { icon: 'ri-truck-line', name: '供应链', desc: '供货、商品数字化、溯源、履约。' },
  { icon: 'ri-restaurant-line', name: '商家', desc: '餐饮、服务、零售等实体经营主体。' },
  { icon: 'ri-government-line', name: '县域运营主体', desc: '负责区域节点建设和运营。' },
];

// 业务场景层（六大场景）
export const sixScenes = [
  { no: '01', icon: 'ri-shopping-cart-2-line', name: '数字买货', desc: '精选商品、农特产品、区域商品' },
  { no: '02', icon: 'ri-price-tag-3-line', name: '数字卖货', desc: '数字货架、云店、分享销售' },
  { no: '03', icon: 'ri-service-line', name: '数字服务', desc: '服务发布、预约、履约、评价' },
  { no: '04', icon: 'ri-restaurant-2-line', name: '数字聚餐', desc: '聚餐、餐饮消费、权益券、社交' },
  { no: '05', icon: 'ri-database-2-line', name: '数字供应链', desc: '供应商、商品、库存、履约、溯源' },
  { no: '06', icon: 'ri-red-packet-line', name: '数字消费权益', desc: '数字消费、营销权益、红包、核销' },
];

// 交易与权益层动态流程
export const tradeFlow = [
  { id: 'in', label: '商品进入', detail: '供应商将商品资料提交进入平台，开启数字化之旅。' },
  { id: 'digit', label: '数字化', detail: '商品信息标准化，生成可展示、可交易的数字资产。' },
  { id: 'shelf', label: '数字货架', detail: '商品被组织进数字货架，形成统一的商业入口。' },
  { id: 'browse', label: '消费者浏览', detail: '消费者通过 TOMA 或数字货架浏览、发现商品。' },
  { id: 'share', label: '分享/推荐', detail: '云社员分享商品，形成社交化传播与推荐关系。' },
  { id: 'order', label: '下单', detail: '消费者确认购买，生成订单。' },
  { id: 'pay', label: '支付', detail: '通过数字消费权益、红包、券完成支付。' },
  { id: 'fulfill', label: '履约', detail: '供应链/商家完成发货、到店、服务履约。' },
  { id: 'confirm', label: '确认', detail: '消费者确认收货或完成服务。' },
  { id: 'review', label: '评价', detail: '消费者评价，沉淀真实口碑数据。' },
  { id: 'contrib', label: '贡献记录', detail: '系统识别各环节贡献，记录到数据链。' },
  { id: 'settle', label: '清分', detail: '按规则智能计算，七方共利完成价值分配。' },
  { id: 'data', label: '数据回流', detail: '交易数据回流至平台，驱动 AI 分析与产业优化。' },
];

// 平台治理层（八大治理）
export const governance = [
  { icon: 'ri-id-card-line', name: '身份管理', desc: '消费者、云社员、云店长、供应商、运营者等。' },
  { icon: 'ri-checkbox-circle-line', name: '商品治理', desc: '商品审核、上下架、质量管理。' },
  { icon: 'ri-arrow-left-right-line', name: '交易治理', desc: '订单、支付、退款、售后。' },
  { icon: 'ri-coupon-3-line', name: '权益治理', desc: '券、红包、权益规则。' },
  { icon: 'ri-lock-line', name: '数据治理', desc: '数据权限、数据安全、数据留痕。' },
  { icon: 'ri-flow-chart', name: '清分治理', desc: '规则、计算、对账、异常、冲正。' },
  { icon: 'ri-alarm-warning-line', name: '风控治理', desc: '异常交易、异常账户、异常订单。' },
  { icon: 'ri-shield-check-line', name: '合规治理', desc: '平台规则、协议、数据安全、支付边界。' },
];

// 政策 → 能力 → 产品 → 场景 → 结果
export const policyMap = [
  { policy: '数字乡村', ability: '数字商业基础设施', product: '云铺' },
  { policy: '数商兴农', ability: '农产品数字营销', product: '数字货架' },
  { policy: '农产品出村进城', ability: '供应链数字化', product: '供应链' },
  { policy: 'AI+', ability: 'AI 应用服务', product: 'TOMA' },
  { policy: '数据要素', ability: '数据底座', product: 'ePin' },
  { policy: '县域商业', ability: '县乡村商业网络', product: '云铺/云店' },
  { policy: '数字消费', ability: '消费应用场景', product: '权益/红包' },
  { policy: '智能服务商', ability: 'AI 服务链', product: '四大服务能力' },
];

// 投资人四张图
export const fourDiagrams = [
  {
    no: '01',
    title: '平台架构图',
    question: '九畴云市是什么？',
    answer: '人 + 货 + 店 + 场 + 数据 + AI',
    icon: 'ri-building-2-line',
  },
  {
    no: '02',
    title: '业务闭环图',
    question: '九畴云市怎么运行？',
    answer: '商品 → 数字货架 → 交易 → 履约 → 消费 → 数据 → 清分',
    icon: 'ri-loop-left-line',
  },
  {
    no: '03',
    title: '技术架构图',
    question: '九畴云市靠什么运行？',
    answer: 'TOMA + 数字货架 + ePin + 数字消费 + 数据/清分',
    icon: 'ri-cpu-line',
  },
  {
    no: '04',
    title: '复制扩张图',
    question: '九畴云市怎么做大？',
    answer: '0# → 1# → N# → 县域 → 千县万村',
    icon: 'ri-map-pin-line',
  },
];

// 业务全景图（人货场 + 交易链路）
export const panorama = [
  { name: '人', nodes: ['消费者/云社员', '云店长/云创客', '供应链/商家'] },
  { name: '货', nodes: ['供应链/商品', 'ePin 身份', '数字货架'] },
  { name: '场', nodes: ['云铺/云店', '商家', '县域节点'] },
  { name: '交易', nodes: ['订单', '支付', '履约'] },
  { name: '数据', nodes: ['消费数据', 'TOMA 分析', '贡献识别'] },
  { name: '价值', nodes: ['智能清分', '数据回流', '产业优化', '再次增长'] },
];